// supabase-js's FunctionsHttpError only exposes a generic message ("Edge
// Function returned a non-2xx status code") on error.message — the real
// { error: "..." } body (e.g. "Not authorized to manage this advertiser")
// is on error.context (the raw Response). Read that for the useful message.
//
// Shared by every Supabase Edge Function caller (exportJobsService,
// integrationsService, ...) so they all surface the same real reason instead
// of supabase-js's fixed generic string.
export async function extractFunctionErrorMessage(error) {
  try {
    if (error?.context?.json) {
      const body = await error.context.clone().json();
      if (body?.error || body?.message) return body.error || body.message;
    }
  } catch {
    // fall through to the generic message
  }
  return error?.message ?? "Edge Function error";
}
